import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    offlineAlert: translate({ id: 'transactionBar.messages.offlineAlert' }),
  }))

  return api
}
